import React, { Fragment, useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Btn, ToolTip } from "../../../AbstractElements";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { HtmlTooltipTitle } from "../../../Constants/Constants";
import { HtmlTooltipData, HtmlTooltipSubTitle } from "../../../Data/UiKits/Tooltip";

const HtmlTooltip = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleTooltip = (index: number) => setOpenIndex(openIndex === index ? null : index);

  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={HtmlTooltipTitle} span={HtmlTooltipSubTitle} />
        <CardBody>
          <div className="common-flex">
            {HtmlTooltipData &&
              HtmlTooltipData.map((item, index) => (
                <Fragment key={index}>
                  <Btn color={item.class} id={`html_${index}`} onClick={() => toggleTooltip(index)}>
                    {item.text}
                  </Btn>
                  <ToolTip isOpen={openIndex === index} target={`html_${index}`} toggle={() => toggleTooltip(index)}>
                    {item.tooltip}
                  </ToolTip>
                </Fragment>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default HtmlTooltip;
